import type { EmptyStateTemplateProps } from './index';

export default function EmptyStateTemplate({
  classes,
  illustration,
  icon,
  heading,
  description,
  actions,
}: EmptyStateTemplateProps) @{
  <div class={classes} data-dls-component="EmptyState">
    @if (illustration !== undefined) {
      <div class="empty-state-illustration">{illustration}</div>
    }
    @if (icon !== undefined) {
      <div class={icon.classes} aria-hidden="true" style={icon.style}>{icon.content}</div>
    }
    {heading}
    @if (description() !== undefined) {
      <p class="empty-state-description">{description()}</p>
    }
    @if (actions.length > 0) {
      <div class="empty-state-actions">{actions}</div>
    }
  </div>
}
